/** Flag glyph for the icon-only "Report" buttons (novel, author profile, comment). */
export function FlagIcon({ size = 18 }: { size?: number }) {
  return (
    <svg
      className="detail-icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4 22V4" />
      <path d="M4 4h12l-2 4 2 4H4" />
    </svg>
  );
}
